import api from "../api/axios";

/* ---------- PICK UP SERVICES ---------- */
export const getPickUpServices = () => api.get("api/pickups/get-pickups");

export const createPickUpService = (data) =>
  api.post("api/pickups/create-pickup", data);

// services/pickUpService.js
export const updatePickUpService = (id, payload) =>
  api.put(`api/pickups/update-pickup-status/${id}`, payload);

export const deletePickUpService = (id) =>
  api.delete(`api/pickups/delete-pickup/${id}`);
